export default "__VITE_ASSET__B8ffc9y1__"